import { Link } from 'react-router-dom';
import { GiMagnifyingGlass } from 'react-icons/gi';
import { FaLightbulb, FaMoon } from 'react-icons/fa';

import { Search } from './Search';

export const Navbar = ({ darkTheme, setDarkTheme }) => {
  return (
    <div className='p-5 pb-2 flex flex-wrap sm:justify-between justify-center items-center border-b dark:border-gray-700 border-gray-200'>
      <div className='flex flex-col md:flex-row justify-between items-center space-x-5 w-screen'>
        <Link to='/'>
          <p className='text-2xl flex flex-row justify-center items-center leading-5 py-1 px-2 rounded bg-blue-500 font-bold text-white dark:bg-gray-500 dark:text-gray-900'>
            What
            <GiMagnifyingGlass className='ml-1' />
          </p>
        </Link>
        <Search />
        <button
          type='button'
          className='text-xl dark:bg-gray-50 dark:text-gray-900 bg-white border rounded-full px-2 py-1 hover:shadow-lg flex flex-row leading-4 mt-3 sm:mt-0'
          onClick={() => setDarkTheme((prev) => !prev)}
        >
          {darkTheme ? (
            <>
              Light <FaLightbulb color='#ffbb73' className='ml-1' />
            </>
          ) : (
            <>
              Dark <FaMoon color='#B8AEA3' className='ml-1' />
            </>
          )}
        </button>
      </div>
    </div>
  );
};
